var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Nav, NavItem, NavList, Page, PageHeader, PageHeaderTools, PageSection, PageSectionVariants, } from "@patternfly/react-core";
import { AppTabs } from "../enum/appTabs";
import { Link, NavLink } from "react-router-dom";
import { keys, map } from "lodash";
import { useAppSelector } from "../redux/reduxHook";
export var mainContentId = "main-content-page-layout";
export function AppLayout(_a) {
    var children = _a.children;
    var productCart = useAppSelector(function (state) { return state.productCart; }).productCart;
    var logoProps = {
        href: "/",
    };
    var PageNav = (_jsx(Nav, { className: "home-tabs", id: "nav-primary-simple", "aria-label": "Nav", variant: "horizontal", children: _jsx(NavList, { id: "nav-list-simple", children: map(keys(AppTabs), function (key) {
                var tab = AppTabs[key];
                return (_jsx(NavItem, { itemId: tab.id, children: _jsx(NavLink, { to: "".concat(tab.path), children: tab.label }) }, tab.id));
            }) }) }));
    var badgeCountObjectNotRead = {
        isRead: false,
        count: (productCart === null || productCart === void 0 ? void 0 : productCart.length) || 0,
        className: "custom-badge-unread",
    };
    var headerTools = function () {
        return (_jsx(PageHeaderTools, { children: _jsx(Button, { component: function (props) { return _jsx(Link, __assign({}, props, { to: "/cart" })); }, variant: "link", countOptions: badgeCountObjectNotRead, children: "Cart" }) }));
    };
    var Header = (_jsx(PageHeader, { logoProps: logoProps, logo: "React to lit", className: "react-to-lit-header", topNav: PageNav, headerTools: headerTools() }));
    return (_jsx(Page, { mainContainerId: mainContentId, header: Header, children: _jsx(PageSection, { variant: PageSectionVariants.light, children: children }) }));
}
